
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../BaseUrl";


export const GET_T_ExaminationForm_SelectAPI = createAsyncThunk("GET_T_ExaminationForm_Select", async ({ data }) => {
    const {
        M_FinancialYearID,
        M_MonthID,
        T_ExaminationFormID,
        M_MainSubjectID,
        M_SubSubjectID,
        OptionalSub_M_IndicatorID,
        Flag,
        FromTop,
        ToTop,
        token,
        handleExcelData
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/Transaction/GET_T_ExaminationForm_Select?M_FinancialYearID=${M_FinancialYearID}&M_MonthID=${M_MonthID}&T_ExaminationFormID=${T_ExaminationFormID}&M_MainSubjectID=${M_MainSubjectID}&M_SubSubjectID=${M_SubSubjectID}&OptionalSub_M_IndicatorID=${OptionalSub_M_IndicatorID}&Flag=${Flag}&FromTop=${FromTop}&ToTop=${ToTop}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                if (result.data?.table && result.data?.table?.length > 0) {
                    handleExcelData && handleExcelData()
                }
                return result.data
            } else {
                return result
            }
        })
})

const GET_T_ExaminationForm_SelectSlice = createSlice({
    name: "GET_T_ExaminationForm_Select",
    initialState: {
        isLoading: false,
        TableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(GET_T_ExaminationForm_SelectAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(GET_T_ExaminationForm_SelectAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.TableData = action.payload;
        });
        builder.addCase(GET_T_ExaminationForm_SelectAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.TableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})
export const GET_T_ExaminationForm_SelectReducer = GET_T_ExaminationForm_SelectSlice.reducer



export const Export_ExaminationForm_SelectAPI = createAsyncThunk("Export_ExaminationForm_Select", async ({ data }) => {
    const {
        M_FinancialYearID,
        M_MonthID,
        T_ExaminationFormID,
        M_MainSubjectID,
        M_SubSubjectID,
        OptionalSub_M_IndicatorID,
        Flag,
        FromTop,
        ToTop,
        token
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/Transaction/GET_T_ExaminationForm_Select?M_FinancialYearID=${M_FinancialYearID}&M_MonthID=${M_MonthID}&T_ExaminationFormID=${T_ExaminationFormID}&M_MainSubjectID=${M_MainSubjectID}&M_SubSubjectID=${M_SubSubjectID}&OptionalSub_M_IndicatorID=${OptionalSub_M_IndicatorID}&Flag=${Flag}&FromTop=${FromTop}&ToTop=${ToTop}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const Export_ExaminationForm_SelectSlice = createSlice({
    name: "Export_ExaminationForm_Select",
    initialState: {
        isExcelLoading: false,
        ExcelData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(Export_ExaminationForm_SelectAPI.pending, (state, action) => {
            state.isExcelLoading = true;
        });
        builder.addCase(Export_ExaminationForm_SelectAPI.fulfilled, (state, action) => {
            state.isExcelLoading = false;
            state.ExcelData = action.payload;
        });
        builder.addCase(Export_ExaminationForm_SelectAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExcelLoading = false;
            state.isError = true;
            state.ExcelData = null;
            // toastErrorr('Something went wrong')
        });
    },
})
export const Export_ExaminationForm_SelectReducer = Export_ExaminationForm_SelectSlice.reducer